import { BarChart3 } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { JournalistAnalyticsView } from "./JournalistAnalyticsView";

export function JournalistAnalyticsPage() {
  return (
    <div>
      <PageHeader
        icon={BarChart3}
        title="Journalist Analytics"
        description="Analyse journalist performance across your network. Track coverage scores, article quality, beat specialisations, and engagement trends over time."
      />
      <JournalistAnalyticsView />
    </div>
  );
}
